import gql from "graphql-tag";

export const UPDATE_PERSONAL_INFO = gql`
	mutation UpdateCurrentUserPersonalInfo($personalInfo: UserPersonalInfoInput) {
		UpdateCurrentUserPersonalInfo(personalInfo: $personalInfo) {
			firstName
			lastName
			department
			position
			preferredLanguage
		}
	}
`;

export const UPDATE_PERSONAL_PRODUCTS_INFO = gql`
	mutation UpdateCurrentUserPersonalProductsInfo($personalInfo: UserPersonalInfoInput) {
		UpdateCurrentUserPersonalProductsInfo(personalInfo: $personalInfo) {
			firstName
			lastName
			department
			position
			preferredLanguage
			currency
			dosageMeasureUnit
			simulatorWasteReportingEnabled
		}
	}
`;

export const UPDATE_PROFILE_PICTURE_OR_SIGNATURE = gql`
	mutation UpdateProfilePictureOrSignature($userProfileOrSignatureInput: UserProfileOrSignatureInput) {
		UpdateProfilePictureOrSignature(userProfileOrSignatureInput: $userProfileOrSignatureInput) {
			sourceUserPicture
			editedUserPicture
		}
	}
`;

export const UPDATE_AGREEMENTS_TABLE_COLUMNS = gql`
	mutation UpdateAgreementsTableColumns($agreementsColumns: [String!]) {
		UpdateAgreementsTableColumns(agreementsColumns: $agreementsColumns)
	}
`;

export const UPDATE_SIMULATIONS_TABLE_COLUMNS = gql`
	mutation UpdateSimulationsTableColumns($simulationsColumns: [String!]) {
		UpdateSimulationsTableColumns(simulationsColumns: $simulationsColumns)
	}
`;

export const UPDATE_TRANSACTIONS_TABLE_COLUMNS = gql`
	mutation UpdateTransactionsTableColumns($transactionsColumns: [String!]) {
		UpdateTransactionsTableColumns(transactionsColumns: $transactionsColumns)
	}
`;

export const UPDATE_DOCUMENTS_TABLE_COLUMNS = gql`
	mutation UpdateDocumentsTableColumns($documentsColumns: [String!]) {
		UpdateDocumentsTableColumns(documentsColumns: $documentsColumns)
	}
`;

export const UPDATE_TRANSACTIONS_IN_REFUND_INVOICE_DOCUMENT_TABLE_COLUMNS = gql`
	mutation UpdateTransactionsInRefundInvoiceDocumentTableColumns($transactionsInRefundInvoiceDocumentTableColumns: [String!]) {
		UpdateTransactionsInRefundInvoiceDocumentTableColumns(
			transactionsInRefundInvoiceDocumentTableColumns: $transactionsInRefundInvoiceDocumentTableColumns
		)
	}
`;

export const UPDATE_TRANSACTIONS_IN_CREDIT_NOTE_DOCUMENT_TABLE_COLUMNS = gql`
	mutation UpdateTransactionsInCreditNoteDocumentTableColumns($transactionsInCreditNoteDocumentTableColumns: [String!]) {
		UpdateTransactionsInCreditNoteDocumentTableColumns(
			transactionsInCreditNoteDocumentTableColumns: $transactionsInCreditNoteDocumentTableColumns
		)
	}
`;

export const UPDATE_TRANSACTIONS_IN_FREE_OF_CHARGE_DOCUMENT_TABLE_COLUMNS = gql`
	mutation UpdateTransactionsInFreeOfChargeDocumentTableColumns($transactionsInFreeOfChargeDocumentTableColumns: [String!]) {
		UpdateTransactionsInFreeOfChargeDocumentTableColumns(
			transactionsInFreeOfChargeDocumentTableColumns: $transactionsInFreeOfChargeDocumentTableColumns
		)
	}
`;

export const UPDATE_RECORDS_TABLE_COLUMNS = gql`
	mutation UpdateRecordsTableColumns($recordsColumns: [String!]) {
		UpdateRecordsTableColumns(recordsColumns: $recordsColumns)
	}
`;

export const UPDATE_FORMS_TABLE_COLUMNS = gql`
	mutation UpdateFormsTableColumns($formsColumns: [String!]) {
		UpdateFormsTableColumns(formsColumns: $formsColumns)
	}
`;

export const GET_USER_PROFILE_INFO_DATA = gql`
	query GetUserProfileInfoData($input: ProfileDataInfoInput) {
		GetUserProfileInfoData(input: $input) {
			defaultMessageSharingType
			sourceUserPicture
			editedUserPicture
			sourceUserSignature
			editedUserSignature
			isSignatureCreationDraw
			notificationCount
			questsCount
			agreementsTableColumns
			documentsTableColumns
			transactionsInRefundInvoiceDocumentTableColumns
			transactionsInCreditNoteDocumentTableColumns
			transactionsInFreeOfChargeDocumentTableColumns
			transactionsTableColumns
			recordsTableColumns
			formsTableColumns
			country {
				name
				alpha2Code
				alpha3Code
			}
		}
	}
`;

export const GET_LIBRARY_USER_DOMAINS = gql`
	query GetLibraryUserDomains($userId: ID!) {
		users(where: { id: $userId }) {
			simulatorWasteReportingEnabled
			simulationsTableColumns
			domainWithChildren {
				id
				name
				level
			}
		}
	}
`;

export const GET_PROFILE_PICTURE = gql`
	query GetUserProfilePicture($id: ID, $email: String, $isQuerySourceImage: Boolean) {
		GetUserProfilePicture(id: $id, email: $email, isQuerySourceImage: $isQuerySourceImage) {
			sourceUserPicture
			editedUserPicture
		}
	}
`;

export const GET_USER_NOTIFICATION_COUNT = gql`
	query GetNotificationCount {
		GetNotificationCount {
			notificationCount
		}
	}
`;
